const subPages = [{
  label: 'Dane podmiotu',
  route: 'details',
}, {
  label: 'Rejest odbiorów',
  route: 'collections',
}];

export { subPages };
